export default "skymp5-front/f364d460c0f09e8642eb7eabd6801fc4.png";